<template>
  <div class="productpool-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入产品池名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加产品池</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="50%"
            :mask-closable="false"
            :styles="styles">
      <Form :model="productpool"
            label-position="top"
            ref="productpoolValidate"
            action="javascript:void(0)">
        <FormItem label="产品池名称">
          <Input v-model="productpool.name"
                 placeholder="请输入产品池名称" />
        </FormItem>
        <FormItem label="简介">
          <Input v-model="productpool.tag"
                 placeholder="请输入简介" />
        </FormItem>
        <FormItem label="默认价格">
          <Input v-model="productpool.price"
                 placeholder="请输入默认价格" />
        </FormItem>
        <FormItem label="排序"
                  label-position="top">
          <Input v-model="productpool.sort"></Input>
        </FormItem>
        <FormItem label="是否回收">
          <RadioGroup v-model="productpool.is_recovery">
            <Radio label="0"
                   border>否</Radio>
            <Radio label="1"
                   border>是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="产品池介绍">
          <UEditor v-model="productpool.describe"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="赠送">
          <RadioGroup v-model="productpool.is_zengsong">
            <Radio label="0">不支持</Radio>
            <Radio label="1">支持</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="createpushtype('productpoolValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UEditor from "../../common/ueditor";

export default {
  name: "productpool-list",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      showrecovery: false,
      loading: true,
      dataloading: true,
      formItem: {},
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "产品池名称",
          key: "name",
          fixed: "left"
        },
        {
          title: "默认价格",
          key: "price",
          fixed: "left"
        },
        {
          title: "赠送",
          minWidth: 100,
          align: "center",
          key: "is_zengsong",
          render: (h, params) => {
            return h(
              "div",
              params.row.is_zengsong == "0"
                ? "否"
                : "是"
            );
          }
        },
        {
          title: "状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: !params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "修改时间",
          key: "updated_at",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showProbabilityList(params.row.id);
                    }
                  }
                },
                "抽奖规则"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showGoodList(params.row.id);
                    }
                  }
                },
                "商品列表"
              ),

              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      statusList: [
        { id: 0, name: "正常" },
        { id: 1, name: "禁用" }
      ],
      productpooldata: {
        status: "0"
      },
      productpool: {
        is_recovery: "0",
        fare_type: "0",
        is_zengsong: "0",
        sort: "0"
      },
      showModalStatus: false,
      editor: {},
      productpoolValidate: {}
    };
  },
  // 计算
  computed: {},
  components: {
    UEditor
  },
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.renderTable(1);
      // var self = this;
      // this.$api.productpool
      //   .list({
      //     page: this.pages.page,
      //     size: this.pages.size
      //   })
      //   .then(res => {
      //     this.dataloading = false;
      //     if (res.code == 200) {
      //       self.tablelist = res.result.list;
      //       self.pages.total = res.result.total;
      //       this.$Message.success(res.msg);
      //     }
      //   });
      return;
    },
    showGoodList (id) {
      this.$router.push("/productpoolgood/list/" + id);
    },
    showProbabilityList (id) {
      this.$router.push("/productpool/probability?pool_id=" + id);
    },

    // 展开添加
    showModel () {
      this.productpoolid = 0;
      this.productpool = {
        is_recovery: "0",
        describe: "",
        fare_type: "0",
        is_zengsong: "0",
        sort: "0"
      };
      this.$refs["editContent"].message = "";
      this.$refs["productpoolValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function (index) {
      this.productpoolid = index;
      this.showModalStatus = !this.showModalStatus;
      this.$api.productpool.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.productpool = res.result.productpool;
          this.$refs["editContent"].message = res.result.productpool.describe;
          this.productpool.is_recovery = this.productpool.is_recovery.toString();
          this.productpool.is_zengsong = this.productpool.is_zengsong.toString();

        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype (name) {
      this.productpool.describe = this.$refs["editContent"].message;
      if (
        this.productpoolid == null ||
        this.productpoolid == 0 ||
        this.productpoolid == undefined
      ) {
        this.$api.productpool
          .create({ productpool: this.productpool })
          .then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.productpool.name = "";
              this.getTableList();
            }
          });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.productpool.id = this.productpoolid;
        this.$api.productpool
          .edit({ productpool: this.productpool })
          .then(res => {
            if (res.code == 200) {
              this.getTableList();
              this.showModalStatus = false;
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
          });
      }
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key,
        status: this.formItem.status
      };
      // console.log(ps);
      this.tablelist = [];
      this.$api.productpool.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.productpool.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.productpool.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        } else {
          this.getTableList();
        }
      });
    }
  }
};
</script>

